/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface SpotlightRequestSchema {
  /**
     * @minItems 1
     * @maxItems 50
     */
  profile_ids: string[];
  search_id?: string | null;
}
